import {apiCall} from 'library';

export async function getManualSections() {
    return apiCall('/api/manual');
}

export async function getManualSection(slug) {
    return apiCall(`/api/manual/${slug}`);
}
